export const COMBO_BOX_HEADER_HORIZONTAL_PADDING_PX = 20;
export const COMBO_BOX_HEADER_BORDER_WIDTH_PX = 2;
export const COMBO_BOX_ACTION_ICON_WIDTH_PX = 40;
export const COMBO_BOX_CLEAR_ICON_WIDTH_PX = 40;
export const COMBO_BOX_ROUNDING_BUFFER_PX = 1;

export const COMBO_BOX_PREFIX_GAP_PX = 5;
export const COMBO_BOX_PREFIX_MIN_WIDTH_PX = 32;

export const COMBO_BOX_DROPDOWN_HORIZONTAL_PADDING_PX =
    COMBO_BOX_HEADER_HORIZONTAL_PADDING_PX +
    COMBO_BOX_HEADER_BORDER_WIDTH_PX +
    COMBO_BOX_ROUNDING_BUFFER_PX;
